export default "/images/0a924eb8d612bc61f532c4f9f678cecf.jpg";